import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import TaskCalendarDatePicker from './TaskCalendarDatePicker';
import type { TaskCalendarView } from './model/useTaskCalendar';

export type TaskCalendarToolbarProps = {
    view: TaskCalendarView;
    title: string;
    currentDate: Date;
    onViewChange: (view: TaskCalendarView) => void;
    onPrev: () => void;
    onNext: () => void;
    onToday: () => void;
    onGoToDate: (date: Date) => void;
};

const VIEWS: Array<{ id: TaskCalendarView; labelKey: string; icon: string }> = [
    { id: 'dayGridMonth', labelKey: 'calendar.viewMonth', icon: 'calendar3' },
    { id: 'timeGridWeek', labelKey: 'calendar.viewWeek', icon: 'calendar-week' },
    { id: 'timeGridDay', labelKey: 'calendar.viewDay', icon: 'calendar-date' },
];

const TaskCalendarToolbar = ({
    view,
    title,
    currentDate,
    onViewChange,
    onPrev,
    onNext,
    onToday,
    onGoToDate,
}: TaskCalendarToolbarProps) => {
    const { t } = useTranslation(['Tasks']);

    return (
        <div className="task-calendar__toolbar d-flex flex-wrap align-items-center gap-2 mb-2">
            <div className="btn-group btn-group-sm">
                <Button
                    size="sm"
                    variant="light-secondary"
                    onClick={onPrev}
                    aria-label={t('calendar.prev')}
                >
                    <SolarIcon name="chevron-left" aria-hidden="true" />
                </Button>
                <Button size="sm" variant="light-secondary" onClick={onToday}>
                    {t('calendar.today')}
                </Button>
                <Button
                    size="sm"
                    variant="light-secondary"
                    onClick={onNext}
                    aria-label={t('calendar.next')}
                >
                    <SolarIcon name="chevron-right" aria-hidden="true" />
                </Button>
            </div>

            <TaskCalendarDatePicker
                title={title}
                currentDate={currentDate}
                onGoToDate={onGoToDate}
            />

            <div className="btn-group btn-group-sm ms-sm-auto">
                {VIEWS.map((item) => (
                    <Button
                        key={item.id}
                        size="sm"
                        variant={view === item.id ? 'primary' : 'light-secondary'}
                        className="d-inline-flex align-items-center"
                        onClick={() => onViewChange(item.id)}
                    >
                        <SolarIcon name={item.icon} className="me-1" aria-hidden="true" />
                        {t(item.labelKey)}
                    </Button>
                ))}
            </div>
        </div>
    );
};

export default TaskCalendarToolbar;
